export function richText(
  text: string,
  components: Record<string, (children: React.ReactNode, key: number) => React.ReactNode>,
) {
  const regex = /<(\w+)>(.*?)<\/\1>/g;

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  let keyIndex = 0;

  while ((match = regex.exec(text))) {
    const [full, tag, content] = match;

    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const component = components[tag];

    if (component) {
      parts.push(component(content, keyIndex++));
    } else {
      parts.push(content);
    }

    lastIndex = match.index + full.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
}
